import PropTypes from 'prop-types';
import { Col, Row } from "reactstrap";
import InputController from "../../../../../core/ui/components/InputController";
import SelectController from "../../../../../core/ui/components/SelectController";

const REQUIRED_RULE = {
    required: "Este campo es requerido",
};

const InformacionComplementariaTab = ({ errors, control, selects }) => {
    return (
        <Row>
            <Col sm={6}>
                <InputController
                    label="Usuario"
                    errors={errors}
                    control={control}
                    name="usuario"
                    rules={REQUIRED_RULE}
                    placeholder="Usuario"
                />
            </Col>
            <Col sm={6}>
                <SelectController
                    label="Estrato"
                    errors={errors}
                    control={control}
                    rules={REQUIRED_RULE}
                    name="parametro_estrato_id"
                    options={selects.estratosSociales}
                />
            </Col>
            <Col sm={6}>
                <InputController
                    type="number"
                    errors={errors}
                    control={control}
                    name="personas_a_cargo"
                    label="Personas a cargo"
                />
            </Col>
            <Col sm={6}>
                <SelectController
                    errors={errors}
                    control={control}
                    rules={REQUIRED_RULE}
                    label="Nivel educativo"
                    name="parametro_nivel_educativo_id"
                    options={selects.nivelesEducativos}
                />
            </Col>
            <Col sm={6}>
                <SelectController
                    errors={errors}
                    control={control}
                    label="Estado civil"
                    rules={REQUIRED_RULE}
                    options={selects.estadosCiviles}
                    name="parametro_estado_civil_id"
                />
            </Col>
            <Col sm={6}>
                <SelectController
                    label="EPS"
                    errors={errors}
                    control={control}
                    rules={REQUIRED_RULE}
                    name="entidad_salud_id"
                    options={selects.entidadesSalud}
                />
            </Col>
            <Col sm={6}>
                <SelectController
                    errors={errors}
                    control={control}
                    rules={REQUIRED_RULE}
                    label="Tipo de sangre"
                    options={selects.tiposSangre}
                    name="parametro_tipo_sangre_id"
                />
            </Col>
            <Col sm={6}>
                <InputController
                    type="date"
                    errors={errors}
                    control={control}
                    name="fecha_ingreso"
                    label="Fecha de ingreso"
                    placeholder="Fecha de ingreso"
                />
            </Col>
        </Row>
    );
};

InformacionComplementariaTab.propTypes = {
    errors: PropTypes.object,
    control: PropTypes.object,
    selects: PropTypes.object,
};

export default InformacionComplementariaTab;
